import React from 'react';

import { useAppTranslations } from '@treneo/shared/i18n';
import { BaseModal } from '@treneo/shared/ui';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const MyAccountModal = ({ open, onClose, children }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('userMenu.myAccount')}
      variant='positioned'
      maxWidth='600px'
    >
      {children}
    </BaseModal>
  );
};
